module.exports = __webpack_public_path__ + "img/1608122867.3386b869.png";